export const PRODUCT_REQUEST = 'PRODUCT_REQUEST'
export const ADD_PRODUCT_SUCCESS = 'ADD_PRODUCT_SUCCESS'
export const PRODUCT_FAIL = 'PRODUCT_FAIL'